let _token: string | null = null;
export default {
    set: (token: string): void => {
        _token = token;
    },
    get: (): string | null => _token,
};
